export const env = () => {
    const host = window.location.hostname

    if ([ 'local', 'dev', 'v2.dev', 'qa', 'qe' ].some(e => host.startsWith(e))) {
        return 'development'
    }
    return 'production'
}
